const settingsIndex = '/employer/settings';

export default {
	login: '/login',
	register: '/register',
	employer: '/employer',
	employerDashboard: '/employer/dashboard',
	exitSurveys: '/employer/exit-surveys',
	exitSurveyForm: '/exit-survey/:token',
	surveys: '/employer/surveys',
	surveyForm: '/survey/:token',
	/** Base path; redirects to {@link reportingCandidateSummary}. */
	reporting: '/employer/reporting',
	reportingCandidateSummary: '/employer/reporting/candidate-summary',
	reportingFraudDetection: '/employer/reporting/fraud-detection',
	addReferees: '/addReferees',
	addReference: '/addReference',
	forgotPassword: '/forgotPassword',
	setPassword: '/setPassword',
	requestInvite: '/requestInvite',
	settings: {
		index: settingsIndex,
		notifications: `${settingsIndex}/notifications`,
		developer: `${settingsIndex}/developer`,
		organisation: `${settingsIndex}/organisation`,
		subscription: `${settingsIndex}/subscription`,
		billing: `${settingsIndex}/billing`,
		buyCredits: `${settingsIndex}/buyCredits`,
		usersAndTeams: `${settingsIndex}/usersAndTeams`,
		helpCentre: `${settingsIndex}/helpCentre`,
	},
	admin: '/admin',
	talentPool: '/employer/talentPool',
	vacancyPool: '/employer/vacancyPool',
	inbound: '/employer/inbound',
	adminQuestionProfiles: '/employer/admin/questionProfiles',
	unauthorised: '/unauthorised',
	preview: '/employer/preview',
};
